import { on, off, removeClass, addClass, findIn } from "@elements/dom-utils";
import { onFind } from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-checkout-country-info', function(baseElement){
        let billingAddressInput = findIn('.js-checkout-country-info__billing-input', baseElement);
        let shippingAddressInput = findIn('.js-checkout-country-info__shipping-input', baseElement);
        let infoElement = findIn('.js-checkout-country-info__info', baseElement);

        const handleChange = (evt) => {
            let selectedOption = evt.target.options[evt.target.selectedIndex];
            if (selectedOption.hasAttribute('data-checkout-country-info')) {
                removeClass('d-none', infoElement);
            } else {
                addClass('d-none', infoElement);
            }
        }

        on('change', handleChange, billingAddressInput);

        on('display-dependent-changed', (evt) => {
            addClass('d-none', infoElement);
            if(_config.isShippingOpen) {
                on('change', handleChange, shippingAddressInput);
                off('change', handleChange, billingAddressInput);
            } else {
                off('change', handleChange, billingAddressInput);
                on('change', handleChange, billingAddressInput);
                off('change', handleChange, shippingAddressInput);
            }
        }, baseElement);
    });

}